import { render } from "./Loading.vue?vue&type=template&id=75227224&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=75227224&scoped=true&lang=css"

import exportComponent from "/home/runcloud1user/webapps/brightflame/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75227224"]])

export default __exports__